const MuiPalette = {
  text: {
    primary: '#252525',
  },
};

export default MuiPalette;
